<template>
  <div class="applicationType">
    <div class="div-layout">
      <div class="applicationType-main">
        <module-title title="">
          <div class="right">
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-plus"
              @click="opAddOrEdit('add')"
            >
              添加手册
            </el-button>
          </div>
        </module-title>
        <el-form :model="searchForm" :inline="true" label-position="right" label-width="100px">
          <el-form-item label="发布时间：" prop="dateTime">
            <el-date-picker
              v-model="dateValue"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="dateChange"
            />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-search"
              @click="handleSearchFilter"
            >
              查询
            </el-button>
          </el-form-item>
          <!-- <el-form-item>
              <el-button
                type="primary"
                size="medium"
                @click="resetInput"
                >重置</el-button
              >
            </el-form-item> -->
        </el-form>
        <div class="applicationType-main-contain">
          <div class="applicationType-list">
            <el-table
              v-loading="listLoading"
              :data="manualList"
              highlight-current-row
              fit
              element-loading-text="Loading"
              class="list-table"
            >
              <el-table-column type="index" width="55" align="center" label="序号" />
              <el-table-column label="版本说明" prop="versionExplain" align="center" width="360px" />
              <el-table-column label="发布时间" prop="createDate" align="center" />
              <el-table-column label="状态" prop="status" align="center" width="100px">
                <template slot-scope="scope">
                  <span v-if="scope.row.status === -1">删除</span>
                  <span v-if="scope.row.status === 1">已发布</span>
                  <span v-if="scope.row.status === 2">已下架</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="left" width="260px">
                <template slot-scope="scope">
                  <!-- <el-button
                  type="success"
                  size="small"
                  icon="el-icon-view"
                  @click="opAddOrEdit('view',scope.row)"
                >预览</el-button> -->
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-edit"
                    @click="updateRow('edit',scope.row)"
                  >
                    编辑
                  </el-button>
                  <el-button
                    v-if="scope.row.status === 2"
                    type="primary"
                    size="small"
                    @click="updateStatus('up',scope.row)"
                  >
                    上架
                  </el-button>
                  <el-button
                    v-if="scope.row.status === 1"
                    type="primary"
                    size="small"
                    @click="updateStatus('down',scope.row)"
                  >
                    下架
                  </el-button>
                  <el-button
                    v-if="scope.row.status === 2"
                    type="danger"
                    size="small"
                    icon="el-icon-delete"
                    @click="handleDdelete(scope.row)"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <pagination
              :total="searchForm.total"
              :page.sync="searchForm.pageNum"
              :limit.sync="searchForm.pageSize"
              @pagination="pageCurriculumList"
              @handleSizeChange="handleSizeChange"
            />
          </div>
        </div>
      </div>
      <!-- 新增编辑应用类型 -->
      <el-dialog
        v-if="hiddenVariable.dialogEditVisible"
        :close-on-click-modal="false"
        :visible.sync="hiddenVariable.dialogEditVisible"
        :title="handleTitle==='add'?'新增':handleTitle==='edit'?'编辑':'预览'"
        width="960px"
        @close="dialogClose"
      >
        <el-form
          ref="handleForm"
          :model="handleForm"
          :rules="handleRules"
          label-position="right"
          label-width="150px"
          @submit.native.prevent
        >
          <el-form-item label="版本说明：" prop="name">
            <el-input
              v-model="handleForm.name"
              name="name"
              maxlength="100"
              placeholder="请输入版本说明"
              class="handle-form-input"
            />
          </el-form-item>
          <el-form-item label="手册内容：" prop="content">
            <Editor
              v-if="handleTitle!=='view'"
              :editor-content="handleForm.content"
              file-size="500M"
              @editorChange="editorChangeFn"
              @editorChangeText="editorChangeTextFn"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="hiddenVariable.dialogEditVisible = false">
            {{ handleTitle==='view'?'关闭':'取消' }}
          </el-button>
          <el-button
            :loading="ajaxLoading"
            type="primary"
            size="medium"
            @click="handleAddSubject('add')"
          >
            {{ ajaxLoading?'Loading':'发布' }}
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// 获取API
import {
  getProductmanualarticleList,
  addManual,
  updateManual,
  deleteManual
} from '@/api/productOperation/public/manual';
import { mapGetters } from 'vuex';

export default {
  name: 'ManualManage',
  data() {
    return {
      dateValue: '',
      ajaxLoading: false,
      // 弹框标题
      handleTitle: 'add',
      // 所有控制显示隐藏变量
      hiddenVariable: {
        dialogEditVisible: false // 添加编辑
      },
      // 搜索表单
      searchForm: {
        pageNum: 1,
        total: 0,
        startDate: '',
        endDate: '',
        type: '1',
        pageSize: 10
      },
      // 操作表单
      handleForm: {
        name: '',
        content: ''
      },
      handleRules: {
        name: [
          { required: true, message: '版本说明不能为空', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '手册内容不能为空', trigger: 'blur' }
        ]
      },
      updateRowId: '',
      listLoading: false, // 表格刷新loading
      manualList: [] // 列表
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    userCode() {
      return this.userInfo.roleVOList[0].createUserCode;
    }
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    resetInput() {
      this.dateValue = '';
    },
    dateChange(e) {
      console.log(e);
      if (e) {
        this.searchForm.startDate = e[0];
        this.searchForm.endDate = e[1];
      } else {
        this.searchForm.startDate = '';
        this.searchForm.endDate = '';
      }
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.getInfo();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.getInfo();
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.getInfo();
    },
    editorChangeFn(val) {
      this.handleForm.content = val;
    },
    editorChangeTextFn(val) {
      this.handleForm.contentText = val;
    },
    dialogClose() {
      this.$refs['handleForm'].resetFields();
    },
    updateStatus(type, row) {
      var data = {
        status: row.status === 1 ? 2 : 1
      };
      this.$confirm(
        `确定要${row.status === 2 ? '上架' : '下架'}${
          '所选' + '该条'
        }模板么?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          updateManual(row.id, data).then(res => {
            this.hiddenVariable.dialogEditVisible = false;
            this.getInfo();
            this.$notify.success({
              title: 'Success',
              message: '操作成功',
              showClose: false,
              duration: 2000
            });
          });
        })
        .catch(() => {});
    },
    updateRow(type, row) {
      this.updateRowId = row.id;
      this.hiddenVariable.dialogEditVisible = true;
      this.handleTitle = type;
      this.handleForm.name = row.versionExplain;
      this.handleForm.content = row.content;
    },
    opAddOrEdit(type) {
      this.handleForm.name = '';
      this.handleForm.content = '';
      this.hiddenVariable.dialogEditVisible = true;
      this.handleTitle = type;
    },
    handleAddSubject() {
      this.$refs['handleForm'].validate((valid) => {
        if (valid) {
          const data = {
            type: '1',
            versionExplain: this.handleForm.name,
            content: this.handleForm.content,
            publishScope: '',
            createUserCode: this.userCode
          };
          console.log(this.handleTitle);
          if (this.handleTitle === 'add') {
            addManual(data).then(res => {
              console.log(res);
              this.hiddenVariable.dialogEditVisible = false;
              this.getInfo();
              this.$notify.success({
                title: 'Success',
                message: '操作成功',
                showClose: false,
                duration: 2000
              });
            });
          } else {
            updateManual(this.updateRowId, data).then(res => {
              this.hiddenVariable.dialogEditVisible = false;
              this.getInfo();
              this.$notify.success({
                title: 'Success',
                message: '操作成功',
                showClose: false,
                duration: 2000
              });
            });
          }
        }
      });
    },
    // 删除
    handleDdelete(row) {
      this.$confirm('此操作将永久删除该手册, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteManual(row.id).then(res => {
          this.getInfo();
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 获取列表
    getInfo() {
      this.listLoading = true;
      // this.searchForm.productId = this.currentProdeuctId;
      getProductmanualarticleList(this.searchForm)
        .then(result => {
          this.manualList = result.data.list;
          this.searchForm.total = result.data.total;
          this.listLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.listLoading = false;
          this.manualList = [];
          this.searchForm.total = 0;
        });
    }
  }
};
</script>
<style lang="scss">
.contentWH img{
  max-width: 100%;
  max-height: 100%;
}
.contentWH .ql-video{
  max-width: 100%;
  max-height: 100%;
}
</style>
<style lang="scss" scoped>
.applicationType {
  padding-bottom: 20px;
  .applicationType-main {
    .applicationType-main-contain {
      // display: flex;
    }
  }
}
.handle-form-input {
  width: 150px;
}

.handle-form-input {
  width: 80%;
}
</style>
